<template>
<div class="chapter">
<div class="inner_page">
<p class="pref"><a id="ch00_fm02_pref"></a><a id="page_ii"></a><span class="small">CULTURE, LABOR, HISTORY</span><br/><em>General Editors:</em> Daniel Bender and Kimberley L. Phillips</p>
<p class="pref"><em>Unknown Class:<br/>Undercover Investigations of American Work and Poverty<br/>from the Gilded Age to the Present</em><br/>Mark Pittenger</p>
<p class="pref"><em>Working the Diaspora:<br/>The Impact of African Labor on the Anglo-American World,</em> 1650∇1850<br/>Frederick C. Knight</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm02_pref.vue?38c13972